import { createContext } from 'react';

import type { Config } from 'server/types';

const configsContext = createContext<Config>({
    mode: 'unknown' as never,
    environment: 'unknown' as never,
    settings: {}
});

export default configsContext;
